import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) =>
	({
		fieldLabel: {
			marginBottom: 4,
		},
	} satisfies Record<string, CSSObject>);
